import { render, staticRenderFns } from "./simulationExam.vue?vue&type=template&id=57e1dbd3&scoped=true&"
import script from "./simulationExam.vue?vue&type=script&lang=js&"
export * from "./simulationExam.vue?vue&type=script&lang=js&"
import style0 from "./simulationExam.vue?vue&type=style&index=0&id=57e1dbd3&scoped=true&lang=css&"
import style1 from "./simulationExam.vue?vue&type=style&index=1&id=57e1dbd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1dbd3",
  null
  
)

export default component.exports